import { Component } from '@opten/compiler/metadata/component';

let updateScheduled = false;

function scheduleInlineWidgetsUpdate(): void {
	if (updateScheduled) {
		return;
	}
	updateScheduled = true;
	window.setTimeout(() => {
		updateScheduled = false;
		const auws = (window as any).auws;
		if (auws && typeof auws.updateInlineWidgets === 'function') {
			auws.updateInlineWidgets();
		}
	}, 0);
}

@Component({ className: 'au-widget-car-rating', observe: true })
export class AutoUncleWidgetComponent {
	constructor(element: HTMLElement) {
		scheduleInlineWidgetsUpdate();
	}
}
